import Web3 from "web3"
const axios = require("axios").default
const { ethers } = require("ethers")

const ERC20 = require("../../../abi/lootbox/ERC20.json")
const SwagSale = require("../../../abi/SwagSale.json")

const contracts = {
    hue: {
        network: "zksync",
        chainId: 324,
        paymentToken: { address: "0x3355df6D4c9C3035724Fd0e3914dE96A5a83aaf4", abi: ERC20 }, // USDT
        swagSale: { address: "0xdC8050Fc5B3aD354484f5DC7e50fF0A05FF80797", abi: SwagSale, owner: "", symbol: "HSS" }
    }
    // hue: {
    //     network: "Mumbai",
    //     chainId: 80001,
    //     paymentToken: { address: "0xE097d6B3100777DC31B34dC2c58fB524C2e76921", abi: ERC20 }, // USDC
    //     swagSale: { address: "0x50b055C2C348e5cafac7b548AB37A720090720eD", abi: swagSale },
    //     swagSale: { address: "0x11ac5b3Ab57b2755C28Cb4957208aEC34eF3dfdB", abi: swagSale },
    //     nftCollection: { address: "0x03AD931C53A3e0112f317dd09b8EdC13849d3bFd", abi: NftCollection }
    // }
}

const createTxOptions = async (wallet) => {
    const txOptions = { from: wallet.account, maxFeePerGas: 25000000, maxPriorityFeePerGas: 0 }

    return txOptions
}

const getItemsForSale = async (wallet) => {
    try {
        const web3 = new Web3(window.ethereum)
        // web3.setProvider(wallet.ethereum.provider)
        const swagSale = new web3.eth.Contract(contracts.hue.swagSale.abi, contracts.hue.swagSale.address)

        const itemOptionsSkus = await swagSale.methods.getItemOptions().call()
        console.log("item skus: " + itemOptionsSkus)
        const options = []

        for (let i = 0; i < itemOptionsSkus.length; i++) {
            const item = await swagSale.methods.getItemDetails(itemOptionsSkus[i]).call()
            console.log("item: " + item)
            const meta = await fetchImageFromMetadata(item.tokenURI)
            const imageUri = String(meta?.image)
            console.log("image uri: " + imageUri)
            options.push({
                id: i,
                name: item.SKU,
                imgUrl: imageUri,
                itemPrice: Math.ceil(ethers.utils.formatUnits(item.salePrice, 6)).toString() // decimals hardcoded for now
            })
        }

        return options
    } catch (error) {
        console.log(error)
    }
}

const getUserPaymentAllowance = async (wallet) => {
    try {
        const web3 = new Web3()
        web3.setProvider(wallet.ethereum.provider)
        const paymentToken = new web3.eth.Contract(contracts.hue.paymentToken.abi, contracts.hue.paymentToken.address)

        const allowance = await paymentToken.methods.allowance(wallet.account, contracts.hue.swagSale.address).call()

        return ethers.utils.formatUnits(allowance.toString(), 6).toString()
    } catch (error) {
        console.log(error)
    }
}

const getUserPaymentBalance = async (wallet) => {
    try {
        // console.log("wallet", wallet)
        const web3 = new Web3()
        web3.setProvider(wallet.ethereum.provider)

        const paymentToken = new web3.eth.Contract(contracts.hue.paymentToken.abi, contracts.hue.paymentToken.address)
        // console.log("paymentToken", paymentToken)
        const symbol = await paymentToken.methods.symbol().call()
        // console.log("symbol", symbol)
        const decimals = await paymentToken.methods.decimals().call()
        // console.log("decimals", decimals)
        const balance = await paymentToken.methods.balanceOf(wallet.account).call()
        // console.log("balance", balance)

        return { symbol, decimals, balance: ethers.utils.formatUnits(balance.toString(), decimals).toString() }
    } catch (error) {
        console.log(error)
    }
}

const approveSpender = async (wallet, setDisableModalButtons, setShowConfirmLoading) => {
    setDisableModalButtons(true)
    setShowConfirmLoading(true)
    try {
        const web3 = new Web3(window.ethereum)
        // web3.setProvider(wallet.ethereum.provider)

        const paymentToken = new web3.eth.Contract(contracts.hue.paymentToken.abi, contracts.hue.paymentToken.address)

        const balance = await paymentToken.methods.balanceOf(wallet.account).call()

        const txOptions = await createTxOptions(wallet)
        const approveTx = await paymentToken.methods.approve(contracts.hue.swagSale.address, balance).send(txOptions)
        return approveTx
    } catch (error) {
        console.log(error)
    } finally {
        setDisableModalButtons(false)
        setShowConfirmLoading(false)
    }
}

const buyItem = async (wallet, itemSku, setDisableModalButtons, setShowConfirmLoading, setBuyTx) => {
    setDisableModalButtons(true)
    setShowConfirmLoading(true)
    try {
        const web3 = new Web3(window.ethereum)

        const swagSale = new web3.eth.Contract(contracts.hue.swagSale.abi, contracts.hue.swagSale.address)
        const txOptions = await createTxOptions(wallet)
        console.log("item sku" + itemSku)
        const purchaseTx = await swagSale.methods.purchaseItem(itemSku).send(txOptions)

        setBuyTx(purchaseTx?.transactionHash)
    } catch (error) {
        console.log(error)
    } finally {
        setDisableModalButtons(false)
        setShowConfirmLoading(false)
    }
}

const getUserItems = async (wallet, setErrorMessagePurchased) => {
    const items = []
    try {
        const web3 = new Web3()
        web3.setProvider(wallet.ethereum.provider)

        const itemCollection = new web3.eth.Contract(contracts.hue.swagSale.abi, contracts.hue.swagSale.address)
        const userItems = await itemCollection.methods.getCollectionIds(wallet.account).call()

        const swagSale = new web3.eth.Contract(contracts.hue.swagSale.abi, contracts.hue.swagSale.address)

        //  getBoxOptionDetails
        for (let i = 0; i < userItems.length; i++) {
            const item = await swagSale.methods.getPurchasedProductDetails(userItems[i]).call()
            const tokenURI = await swagSale.methods.tokenURI(userItems[i]).call()
            // console.log("BOX OPTION DETAILS:", boxOption)
            // console.log(`Box Id ${userswagSale[i]} details:`, box)
            const meta = await fetchImageFromMetadata(tokenURI)
            const imageUri = String(meta?.image)

            items.push({
                id: items.length,
                imgUrl: imageUri,
                itemPrice: Math.ceil(ethers.utils.formatUnits(item?.salePrice, 6)).toString(),
                SKU: item?.SKU,
                tokenURI
            })
        }

        // console.log(bxCollection)
        return items
    } catch (error) {
        console.log(error)
        setErrorMessagePurchased(String(error))
    } finally {
    }
}

const fetchImageFromMetadata = async (metadata) => {
    try {
        const res = await fetch(metadata)
        const response = await res.json()
        // console.log("fetchImageFromMetadata", response)

        if (res.status !== 200) {
            // return setErrorFetchingMetadata(true)
        }

        return response
    } catch (err) {
        console.log(err)
    }
}

export { contracts, getUserItems, buyItem, fetchImageFromMetadata, approveSpender, getUserPaymentBalance, getUserPaymentAllowance, getItemsForSale }
